var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraphQlLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    fill: "none",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "#F4F2ED",
    rx: 60
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E535AB",
    d: "M47.8621 176.192L55.2041 180.431L136.997 38.7664L129.655 34.5274L47.8621 176.192Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E535AB",
    d: "M209.766 164.875H46.1809V173.353H209.766V164.875Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E535AB",
    d: "M49.4179 169.637L131.241 216.879L135.48 209.537L53.6569 162.295L49.4179 169.637Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E535AB",
    d: "M120.498 46.5121L202.321 93.7542L206.56 86.4122L124.737 39.1701L120.498 46.5121Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#E535AB",
    d: "M49.4404 86.3797L53.6794 93.7217L135.503 46.4796L131.264 39.1376L49.4404 86.3797Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#E535AB",
    d: "M119.019 38.7675L200.812 180.432L208.154 176.193L126.361 34.5285L119.019 38.7675Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#E535AB",
    d: "M61.145 80.7577H52.667V175.242H61.145V80.7577Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#E535AB",
    d: "M203.331 80.7577H194.853V175.242H203.331V80.7577Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#E535AB",
    d: "M126.095 206.877L129.798 213.291L200.962 172.203L197.259 165.79L126.095 206.877Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#E535AB",
    d: "M214.567 178C209.664 186.529 198.734 189.44 190.205 184.537C181.676 179.634 178.765 168.705 183.668 160.176C188.571 151.646 199.501 148.735 208.03 153.638C216.61 158.592 219.521 169.471 214.567 178Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#E535AB",
    d: "M72.2789 95.8244C67.3759 104.353 56.4464 107.265 47.9173 102.362C39.3882 97.4587 36.4771 86.5292 41.38 78.0001C46.283 69.4709 57.2125 66.5598 65.7416 71.4628C74.2707 76.4168 77.1819 87.2953 72.2789 95.8244Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#E535AB",
    d: "M41.431 178C36.5281 169.471 39.4392 158.592 47.9683 153.638C56.4974 148.735 67.3759 151.646 72.3299 160.176C77.2329 168.705 74.3217 179.583 65.7926 184.537C57.2124 189.44 46.334 186.529 41.431 178Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#E535AB",
    d: "M183.719 95.8244C178.816 87.2953 181.727 76.4168 190.256 71.4628C198.785 66.5598 209.664 69.4709 214.618 78.0001C219.521 86.5292 216.61 97.4076 208.08 102.362C199.551 107.265 188.622 104.353 183.719 95.8244Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#E535AB",
    d: "M127.999 228C118.142 228 110.175 220.033 110.175 210.176C110.175 200.319 118.142 192.351 127.999 192.351C137.856 192.351 145.823 200.319 145.823 210.176C145.823 219.982 137.856 228 127.999 228Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#E535AB",
    d: "M127.999 63.6486C118.142 63.6486 110.175 55.6813 110.175 45.8243C110.175 35.9673 118.142 28 127.999 28C137.856 28 145.823 35.9673 145.823 45.8243C145.823 55.6813 137.856 63.6486 127.999 63.6486Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphQlLight);
export default __webpack_public_path__ + "static/media/GraphQL-Light.2347e8e67bdd88b00fa162ee9f624d97.svg";
export { ForwardRef as ReactComponent };